<template>
  <div class="ksm-flex-1 ksm-flex-column">
    <div class="ksm-flex-1 ksm-flex">
      <div class="ksm-flex-00auto">
        <div class="ksm-medien__icon" v-html="$_getSvg('audio.svg')"></div>
      </div>
      <div class="ksm-flex-1" style="position:relative">
        <div class="ksm-media-wrapper">
          <div style="text-align:center; position: relative;" class="ksm-flex-1">
            <div style="position:absolute; width:100%; height:100%">
              <img
                class="ksm-schallplatten"
                :src="selected_audio==='Audio1924'?$_getIcon('1923.png'):$_getIcon('1932.png')"
                style="max-height:100%;max-width:100%; bottom:0"
              />
            </div>
          </div>
          <audio class="ksm-media">
            <source :src="'./static/multimedia/'+audioSrc" type="audio/mpeg" />Your browser does not support the audio element.
          </audio>
        </div>
      </div>
    </div>

    <div class="ksm-flex-00auto ksm-flex">
      <div class="ksm-flex-00auto ksm-flex-column">
        <div>
          <div class="ksm-medien__audio-select">
            <input
              type="radio"
              name="ksm_audio_radio"
              id="ksm-radio__audio-1924"
              v-model="selected_audio"
              value="Audio1924"
            />
            <label for="ksm-radio__audio-1924">Originalaufnahme 1924</label>
          </div>
          <div class="ksm-medien__audio-select">
            <input
              type="radio"
              name="ksm_audio_radio"
              id="ksm-radio__audio-1932"
              v-model="selected_audio"
              value="Audio1932"
            />
            <label for="ksm-radio__audio-1932">Originalaufnahme 1932</label>
          </div>
        </div>
      </div>

      <div class="ksm-flex-1 ksm-flex-column">
        <div class="ksm-flex-1 ksm-flex"></div>
        <div class="ksm-flex-00auto">
          <PlayerControls
            v-if="media"
            :media="media"
            mediaType="audio"
            @audioChange="audioChange"
            :mediaName="selected_audio"
            @playPause="playPause"
          ></PlayerControls>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlayerControls from "./PlayerControls";

export default {
  components: { PlayerControls },
  props: ["isConnect2"],
  data() {
    return {
      duration: 0,
      media: null,
      selected_audio: "Audio1924",
      isPause: true
    };
  },
  watch: {
    selected_audio(f) {
      const schallplatten = this.$el.querySelector(".ksm-schallplatten");
      schallplatten.classList.remove("ksm-rotating");
      this.media.src = "./static/multimedia/" + this.audioSrc;
      this.media.load();
      // this.media.pause();
      // this.media.currentTime = 0;
    }
  },
  mounted: function() {
    const vue = this;
    const media = this.$el.querySelector(".ksm-media");
    this.media = media;
    const schallplatten = this.$el.querySelector(".ksm-schallplatten");

    vue.$store.state.eventBus.$on("audio-connect-2", function(isConnect2) {
      if (isConnect2 && !vue.isPause) {
        // vue.$store.state.eventBus.$emit("video-play", vue.media.currentTime);
      } else if (isConnect2) {
        // vue.$store.state.eventBus.$emit("video-pause", vue.media.currentTime);
      }
    });

    media.addEventListener("play", function() {
      if (vue.isConnect2) {
        // vue.$store.state.eventBus.$emit("video-play", vue.media.currentTime);
      }
      schallplatten.classList.add("ksm-rotating");
    });

    media.addEventListener("pause", function() {
      if (vue.isConnect2) {
        vue.$store.state.eventBus.$emit("video-pause", vue.media.currentTime);
      }
      schallplatten.classList.remove("ksm-rotating");
    });
  },
  computed: {
    audioSrc() {
      if (this.selected_audio === "Audio1924") {
        return "platte_1923.mp3";
      } else {
        return "platte_1932.mp3";
      }
    }
  },
  methods: {
    audioChange(obj) {
      this.$emit("audioChange", obj);
    },
    playPause(d) {
      this.isPause = d;
    }
  }
};
</script>

<style lang="scss" >
@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.ksm-rotating {
  -webkit-animation: rotating 3s linear infinite;
  -moz-animation: rotating 3s linear infinite;
  -ms-animation: rotating 3s linear infinite;
  -o-animation: rotating 3s linear infinite;
  animation: rotating 3s linear infinite;
}
</style>


// WEBPACK FOOTER //
// AudioView.vue?1b0cd1f7